import { AuthGuard } from '../app.authGuard';
import { StartObserveObservationComponent } from './start-observe-observation/start-observe-observation.component';
import { PhBhpNewObserveObservationComponent } from './ph-bhp-new-observe-observation/ph-bhp-new-observe-observation.component';
import { PhBhpObserveObservationProtocolComponent } from './ph-bhp-observe-observation-protocol/ph-bhp-observe-observation-protocol.component';
import { PhBhpObserveManageQuotaComponent } from './ph-bhp-observe-manage-quota/ph-bhp-observe-manage-quota.component';
import { PhBhpConfigureNewQuotaComponent } from './ph-bhp-observe-new-quota/ph-bhp-observe-new-quota.component';
import { Route } from "@angular/router";

export var ObserveObserveRouterModule: Route =       {
  path: 'observe', component: StartObserveObservationComponent, children: [
    { path: 'newObserve', component: PhBhpNewObserveObservationComponent, canActivate: [AuthGuard] },
    { path: 'observeObservationProtocol', component: PhBhpObserveObservationProtocolComponent, canActivate: [AuthGuard] },
    { path: 'managequota', component: PhBhpObserveManageQuotaComponent, canActivate: [AuthGuard] },
    { path: 'newquota', component: PhBhpConfigureNewQuotaComponent, canActivate: [AuthGuard] },
    { path: 'editquota/:quotaID', component: PhBhpConfigureNewQuotaComponent, canActivate: [AuthGuard] },
    { path: '', redirectTo: 'newObserve', pathMatch: 'full', canActivate: [AuthGuard] },
    { path: '**', redirectTo: 'newObserve', canActivate: [AuthGuard] }
  ]
}
